module.exports = __webpack_public_path__ + "media/images/icon-arrow-up-right-20db255be597d9cd67aa2479b90430e3.svg";